__turbopack_context__.v({
  "root": "Button-module__n3APca__root",
  "transparent": "Button-module__n3APca__transparent",
});
